var _path, _path2, _path3, _path4, _circle, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageAlerts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 54,
    viewBox: "0 0 62 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20833 42.8704C5.30039 42.6101 3.1873 41.4818 2.71544 40.8868L23.8259 19.6674L28.3803 21.4997C31.6792 23.223 35.8685 21.7805 37.4277 20.2213L59.5229 40.9484C58.415 42.4871 55.9327 42.9319 55.03 42.8704H7.20833Z",
    fill: "#FFA000",
    stroke: "#D5A00B",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4613 41.0715L37.3661 20.0982L59.7691 3.60376C60.5076 4.40386 60.9384 5.38861 61 6.55799V36.1003C61 39.8406 59.4613 41.0715 59.4613 41.0715Z",
    fill: "#FEC007",
    stroke: "#D5A00B",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7233 40.901L23.8259 19.4828L2.03843 3.46667C1.29987 4.26678 1.06154 5.51177 0.999998 6.68116V36.2235C0.999998 38.7944 1.98474 40.2856 2.7233 40.901Z",
    fill: "#FABE08",
    stroke: "#D5A00B",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19309 1.01879C4.99267 0.820079 3.20782 2.23566 2.03844 3.46658L23.5797 19.284C26.9032 22.4704 31.3961 24.7617 37.4892 20.1457L59.8922 3.72683C58.7105 1.95429 56.2814 1.18291 55.2146 1.01879H8.19309Z",
    fill: "#FAD14E",
    stroke: "#D5A00B",
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0884,
    cy: 39.6559,
    r: 14.1557,
    fill: "#2196F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.8574,
    y: 30.424,
    width: 2.95423,
    height: 12.9248,
    rx: 1.47712,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.8575,
    y: 45.9336,
    width: 2.95423,
    height: 2.95423,
    rx: 1.47712,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageAlerts);
export default __webpack_public_path__ + "static/media/message-alerts.c2503bd4ab9e389c0fc6952f10d29ae8.svg";
export { ForwardRef as ReactComponent };